import { useTranslation } from "react-i18next";
import hero from "../../assets/hero.png";
import heroAr from "../../assets/hero_ar.png";

import { useLocal } from "hooks/useLocal";
import { HeroIconArSvg, HeroIconSvg } from "assets/images";

type HeroProps = {
  onPrimaryCtaClick?: () => void;
};

export function Hero({ onPrimaryCtaClick }: HeroProps) {
  const { t } = useTranslation(["common"]);
  const { direction, isArabic } = useLocal();
  const dirAttr: string | undefined = Array.isArray(direction)
    ? direction[0]
    : direction;

  return (
    <section
      dir={dirAttr}
      className={`w-full bg-white border-b border-[#EBEBEB] px-6 py-10 ${isArabic ? "font-ibmplex" : "font-inter"}`}
    >
      <div className="flex items-center justify-around max-w-[1400px] mx-auto flex-col md:flex-row">
        {/* left side */}
        <article className="flex flex-col gap-4 md:gap-6 md:max-w-[700px]">
          <p
            className={`font-bold text-[32px] md:text-5xl text-gray md:leading-[56px] ${isArabic ? "font-ibmplex" : "font-funnel"}`}
          >
            {t("heroSection.numuwIsHere")}
          </p>

          <p className="text-[18px] text-[#3D3C56]">
            {t("heroSection.heroDescription")}
          </p>

          <button
            type="button"
            onClick={onPrimaryCtaClick}
            className="hidden md:block bg-[#4242CE] hover:bg-[#4242CE]/90 cursor-pointer text-white text-[16px] font-medium px-4 py-3 rounded-xl transition-colors duration-200 whitespace-nowrap max-w-fit text-center"
          >
            {t("heroSection.bookIntroSessionCta")}
          </button>
        </article>

        {/* right side */}
        <article className="w-full flex justify-center md:justify-end max-w-fit">
          <img
            src={isArabic ? HeroIconArSvg : HeroIconSvg}
            alt={t("heroSection.heroImageAlt") ?? ""}
            className="mt-6 md:mt-0 w-full max-w-[450px]"
          />
        </article>

        {/* mobile CTA */}
        <button
          type="button"
          onClick={onPrimaryCtaClick}
          className="md:hidden mt-6 bg-[#4242CE] text-white text-[16px] font-medium px-4 py-3 rounded-xl transition-colors duration-200 w-full text-center"
        >
          {t("heroSection.bookIntroSessionCta")}
        </button>
      </div>
    </section>
  );
}
